import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './components/loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule } from './icons.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SupportRequestDialogComponent } from './components/support-request-dialog/support-request-dialog.component';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';
import { CookieConsentService } from './services/cookie-consent.service';
import { AbsencePanelComponent } from './components/absence-panel/absence-panel.component';

@NgModule({
    declarations: [
        LoaderComponent,
        ConfirmDialogComponent,
        SnackbarComponent,
        SupportRequestDialogComponent,
        CookieConsentComponent,
        AbsencePanelComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        IconsModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatIconModule,
        MatMenuModule,
        MatRippleModule,
        MatChipsModule,
        MatSlideToggleModule,
        FormsModule,
        MatTableModule,
        MatDividerModule,
        MatTooltipModule,
        MatSelectModule,
        MatCardModule,
        MatSortModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
    ],
    exports: [
        CommonModule,
        RouterModule,
        LoaderComponent,
        AbsencePanelComponent,
        TranslateModule,
        IconsModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatIconModule,
        MatMenuModule,
        MatRippleModule,
        MatChipsModule,
        MatSlideToggleModule,
        FormsModule,
        MatTableModule,
        MatDividerModule,
        MatTooltipModule,
        MatSelectModule,
        MatCardModule,
        MatSortModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        CookieConsentComponent,
    ],
    providers: [CookieConsentService],
})
export class SharedModule {}
